import { Action } from '../actions';
import { EditorState } from '../models/editor';

const DEFAULT_STATE: EditorState = {};

export function editorReducer(state: EditorState | undefined, action: Action): EditorState {
  switch (action.type) {
    case 'newLinkEditorMenu': {
      return {
        ...state,
        selectionMenu: {
          type: 'new_link',
          selection: action.payload,
        },
      };
    }
    case 'editLinkEditorMenu': {
      return {
        ...state,
        selectionMenu: {
          type: 'edit_link',
          selection: action.payload,
        },
      };
    }
    case 'clearEditorMenu': {
      return {
        ...state,
        selectionMenu: undefined,
      };
    }
  }

  return state || DEFAULT_STATE;
}
